var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kyc-container"},[_c('PageHeader',{attrs:{"title":_vm.pageHeaderTitle}}),(_vm.authLevel === 1)?_c('KYC1Auth'):_vm._e(),(_vm.authLevel === 2)?_c('KYC2Auth'):_vm._e(),(_vm.authLevel === 3)?_c('KYC3Auth'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }